import React from 'react';
import Carousels from './carousel';
import Footer from './footer';
import Home from './home';
import Navbars from './Navbar';
const Header = () => {
  return (
    <div className="container-fixed">     
    <Navbars />
      <Carousels />
      <Home />
      <Footer />
    </div>
  );
};
export default Header;
